import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import nodes from '@/store/modules/nodes';
import scroll from '@/store/modules/scroll';
import scale from '@/store/modules/scale';
import version from '@/store/modules/version';
import showJSON from '@/store/modules/showJSON';
import importJSON from '@/store/modules/importJSON';
import visual from '@/store/modules/visual/index';
import visualPositions from '@/store/modules/visual/positions';
import visualConnectors from '@/store/modules/visual/connectors';

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: [
    'version',
    'nodes',
    'scale',
  ],
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    version,
    nodes,
    scale,
    scroll,
    showJSON,
    importJSON,
    visual,
    visualPositions,
    visualConnectors,
  },
  plugins: [vuexLocal.plugin],
  actions: {
    reset(context) {
      context.commit('version/reset', null, { root: true });
      context.commit('scale/reset', null, { root: true });
      context.commit('scroll/reset', null, { root: true });
      context.commit('showJSON/reset', null, { root: true });
      context.commit('importJSON/reset', null, { root: true });
      context.commit('visual/reset', null, { root: true });
      context.commit('visualPositions/reset', null, { root: true });
      context.commit('visualConnectors/reset', null, { root: true });
      context.dispatch('nodes/reset', null, { root: true });
    },
  },
});
